module.exports = __webpack_public_path__ + "static/invoices-emails-header-aa4e004e34d8809ddef41b54101f114e.svg";